export const XP_PER_LESSON = 20;

export function getLevelInfo(totalXp) {
  const levels = [
    { level: 1, min: 0,    max: 99,   label: 'Kezdő' },
    { level: 2, min: 100,  max: 249,  label: 'Tanuló' },
    { level: 3, min: 250,  max: 499,  label: 'Haladó' },
    { level: 4, min: 500,  max: 899,  label: 'Tapasztalt' },
    { level: 5, min: 900,  max: 1399, label: 'Szakértő' },
    { level: 6, min: 1400, max: 9999, label: 'Mester' },
  ];
  const xp = totalXp || 0;
  const current = levels.findLast(l => xp >= l.min) || levels[0];
  const next = levels.find(l => l.level === current.level + 1);
  const progressPct = next
    ? Math.round(((xp - current.min) / (next.min - current.min)) * 100)
    : 100;
  return { ...current, xp, progressPct, nextMin: next?.min };
}
